import ClassesList from 'components/Organization/ClassesList/ClassesList';
import NoClassesFound from 'components/Organization/NoClassesFound/NoClassesFound';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStores } from 'index';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

export const ClassesTab = observer(() => {
  const cs = useStores().classesStore;
  const iss = useStores().inviteStudentsStore;
  const ss = useStores().studentsStore;
  const orgStore = useStores().organizationsStore;
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  useEffect(() => {
    if (selectedOrganizationId) {
      ss.getStudents(selectedOrganizationId);
      ss.getNumberOfStudents(selectedOrganizationId);
      iss.getInvites(selectedOrganizationId);
    }
  }, [selectedOrganizationId, ss, iss]);

  if (!cs.isLoading && !cs.classesList.length) return <NoClassesFound />;

  return <ClassesList />;
});

export default ClassesTab;
